import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LOGO_URL } from "@/lib/publicSite";

export const PublicNav = () => (
  <nav className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-b border-border" data-testid="public-nav">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex items-center justify-between h-14 sm:h-16">
        <Link to="/" className="flex items-center gap-2 sm:gap-3" data-testid="nav-logo">
          <img src={LOGO_URL} alt="Sustainable Handyman Services" className="h-10 w-10 sm:h-12 sm:w-12 rounded-full object-cover" />
          <span className="font-heading font-bold text-primary text-sm sm:text-base md:hidden">SHS</span>
          <span className="font-heading font-bold text-primary hidden md:block">Sustainable Handyman Services</span>
        </Link>
        <div className="flex items-center gap-2 sm:gap-4">
          <Link to="/gallery" className="text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors" data-testid="nav-gallery-link">
            Gallery
          </Link>
          <Link to="/about" className="text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors" data-testid="nav-about-link">
            About
          </Link>
          <Link to="/reviews" className="text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors" data-testid="nav-reviews-link">
            Reviews
          </Link>
          <Link to="/enquiry" data-testid="nav-enquiry-btn">
            <Button size="sm" className="rounded-full bg-accent hover:bg-accent/90 text-accent-foreground text-xs sm:text-sm px-3 sm:px-4">
              Get Quote
            </Button>
          </Link>
        </div>
      </div>
    </div>
  </nav>
);
